import React, { FunctionComponent } from "react"
import { BatchRow } from "./BatchRow"
import { Paper, Grid, Table, TableBody, Typography, Button, Tooltip } from "@material-ui/core"
import { BatchItem } from "./BatchItem"
import GetAppIcon from "@material-ui/icons/GetApp"
import { useBatchPageContext } from "./useBatchPageContext"
import InfoIcon from "@material-ui/icons/Info"

interface BatchTableProps {
    rows: BatchItem[]
}

export const BatchTable: FunctionComponent<BatchTableProps> = ({ rows }) => {
    const { exportCSV } = useBatchPageContext()
    const enabledItemCount = rows.filter(item => item.include).length
    const disabledItemCount = rows.length - enabledItemCount
    const activeDescription =
        'Inactive rows are excluded from batch operations like "Translate All" and "Generate All". Inactive rows are included when exporting a csv. '
    return (
        <Grid container direction={"column"} spacing={2}>
            <Grid item>
                <Grid
                    container
                    direction={"row"}
                    justify="space-between"
                    alignItems="flex-end"
                    spacing={3}
                >
                    <Grid item>
                        <Button
                            id={"export-csv-btn"}
                            onClick={exportCSV}
                            variant={"contained"}
                            color={"primary"}
                        >
                            Export CSV
                            <GetAppIcon style={{ marginLeft: ".6em" }} />
                        </Button>
                    </Grid>

                    <Grid item>
                        <Grid container spacing={1} direction="row">
                            <Grid item>
                                <Typography data-testid="active-count" variant="body1">
                                    {`${enabledItemCount} active, ${disabledItemCount} inactive`}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Tooltip
                                    title={
                                        <Typography variant="caption">
                                            {activeDescription}
                                        </Typography>
                                    }
                                    placement={"left"}
                                >
                                    <InfoIcon color="primary" />
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item>
                <Paper>
                    <Table id="batchTable" data-testid="batchTable" size={"small"}>
                        <TableBody>
                            {rows.map(row => (
                                <BatchRow key={row.index} rowItem={row} />
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Grid>
        </Grid>
    )
}
